import styled from "styled-components";

export const Container = styled.div`

    .container{
        display: flex;
        align-items: center;
        margin: 1rem 0;

        .secretCouponExplanation{
            position: relative;
            svg{
                position: absolute;
                top: -12px;
                right: -14px;
                font-size: 17px;
                color: gray;

            }

            &::before{
                    content: 'Cupom não visível ao usuário. Seus benefícios somente podem ser obtidos digitando seu nome no campo de resgate na área de cupons';
                    padding: 1rem;
                    width: 9rem;
                    background: #393939;
                    color: #FFF;
                    text-align: left;
                    border-radius: .3rem;
                    position: absolute;
                    top: 0;
                    right: 0;
                    transform: translate(105%, -106%);
                    opacity: 0;
                    transition: opacity 0.3s ease;
                    pointer-events: none;
            }

            &:hover::before{
                opacity: 1;
            }

        }

    }

`